import React from 'react'
import { Box, BoxProps } from 'rebass'
import { theme, ThemeColorKey } from 'theme'

interface DividerProps extends Omit<BoxProps, 'color'> {
    key?: string
    color?: ThemeColorKey
}

const Divider: React.FC<DividerProps> = ({
    color = theme.newColors.neutral200,
    mx,
    my = theme.spacing.xxxs,
    sx,
    ...props
}) => {
    const mergedSx = {
        borderWidth: '0px',
        borderTopWidth: '1px',
        borderStyle: 'solid',
        borderColor: color,
        ...sx,
    }
    return <Box mx={mx} my={my} sx={mergedSx} {...props} />
}

export default Divider
